export const updateUrlHashForSku = (sku: string | null) => {
  if (typeof window === 'undefined') {
    return
  }
  const url = new URL(window.location.href)
  url.hash = sku || ''
  window.history.replaceState({}, '', url.toString())
}

export const getSkuFromUrlHash = () => {
  if (typeof window === 'undefined') {
    return null
  }
  const hash = window.location.hash.replace('#', '')
  return hash === '' ? null : hash
}
